(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    /**
     * Note that the infinite scroll library has an issue with initially loading
     * enough items to fill the screen (and create a scrollbar). It is documented
     * here: https://github.com/sroze/ngInfiniteScroll/issues/125
     * Controller for markup that chooses one of a list of items.
     */
    angular
        .module('ihh-common-web')
        .controller('ItemChooserCtrl', ItemChooserCtrl);

    ItemChooserCtrl.$inject = ['$scope', 'RestResources'];

    function ItemChooserCtrl($scope, RestResources) {
        $scope.angular = angular; // so we can get at the helper functions without wrapping each separately
        $scope.getCommonHost = function() {
            return RestResources.getCommonHost();
        };
    }
})();